import { useDebouncedSearch } from "@/utils/hooks/useDebouncedSearch";
import { useInfiniteFlightsDetailsQuery } from "@/services/reports";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { AntSelect } from "@/CommonElements/AntSelect";
import { Empty, Flex } from "antd";
import { Spinner } from "reactstrap";

export const SelectFlightDetails = (props) => {
    const { flightDetailsQuery } = props;
    const { debouncedValue, setSearchValue } = useDebouncedSearch("", 500);
    const { getLocalizedText } = useLocalizedText();
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading,
    } = useInfiniteFlightsDetailsQuery({ 
        flight_id: debouncedValue, 
        ...flightDetailsQuery 
    });

    // Flatten all pages - Flight API returns response.data.data (array)
    const flights = data?.pages.flatMap(page => page.data.data) ?? [];

    // Handle scroll to load more
    const handlePopupScroll = (e) => {
        const { target } = e;
        if (
            target.scrollTop + target.offsetHeight === target.scrollHeight &&
            hasNextPage &&
            !isFetchingNextPage
        ) {
            fetchNextPage();
        }
    };

    return (
        <AntSelect
            {...props}
            showSearch
            onSearch={setSearchValue}
            onPopupScroll={handlePopupScroll}
            filterOption={false}
            options={flights.map((flight) => {
                const airlineName = getLocalizedText(
                    flight.airline?.name_ar, 
                    flight.airline?.name_en
                );
                const label = `${flight.id} (${flight.flight_date}) - ${airlineName}`;
                return {
                    value: flight.id,
                    label: label,
                };
            })}
            notFoundContent={isLoading ?
                <Flex align="center" justify="center">
                    <Spinner size="sm" />
                </Flex>
                : <Empty />}
            dropdownRender={(menu) => (
                <>
                    {menu}
                    {(isFetchingNextPage) && (
                        <div style={{ textAlign: 'center', padding: '8px' }}>
                            <Spinner size="sm" />
                        </div>
                    )}
                </>
            )}
        />
    )
}
